import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import ko_KR from 'antd/es/locale/ko_KR'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { pdfjs } from 'react-pdf'
import { RecoilRoot } from 'recoil'
import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { CustomAntdTheme } from './styles/CustomAntdTheme'

// PDF.js worker 설정 (가장 먼저 설정 - react-pdf가 로드되기 전)
if (typeof window !== 'undefined') {
  pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`
}

const client = new QueryClient()
dayjs.locale('ko')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <QueryClientProvider client={client}>
        <ConfigProvider locale={ko_KR} theme={CustomAntdTheme}>
          <App />
        </ConfigProvider>
      </QueryClientProvider>
    </RecoilRoot>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
